import { useSyncExternalStore } from 'react';

/*
 * Whoever is drawing the meeting's "bronnen" panel right now. Held in the
 * module rather than in a context for the same reason the chat's offer is: the
 * drawer that asks for the panel and the page that owns it are nowhere near
 * each other in the tree.
 */
const listeners = new Set<() => void>();

/*
 * How many times it has been asked for, rather than whether it is open. The
 * panel closes itself the ordinary ways — escape, a click outside — and a flag
 * would leave this saying "open" about a panel that is not. Asking twice has to
 * land twice, so it is counted.
 */
let asked = 0;

function askedCount(): number {
  return asked;
}

/**
 * Open the meeting page's "bronnen" panel from elsewhere on the page.
 *
 * The one nudge about documents has nowhere to send anybody: the place to hand
 * a document over is a panel on the page the drawer is already standing beside.
 */
export function openMeetingSourcesPanel(): void {
  asked += 1;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

/**
 * How many times the panel has been asked for. The meeting page opens it
 * whenever this changes.
 */
export function useMeetingSourcesPanelAsked(): number {
  return useSyncExternalStore(subscribe, askedCount, () => 0);
}
